// src/utils/sessionUtils.js
// Utility functions for session management

export const STORAGE_KEYS = {
    LAST_ACTIVITY: 'lastActivity',
    SESSION_CHECK: 'sessionCheck',
    USER_AWAY: 'userAway'
};

// Get the time user was last active
export const getLastActivity = () => {
    const stored = localStorage.getItem(STORAGE_KEYS.LAST_ACTIVITY);
    return stored ? parseInt(stored) : Date.now();
};

// Update last activity time
export const updateLastActivity = () => {
    localStorage.setItem(STORAGE_KEYS.LAST_ACTIVITY, Date.now().toString());
};

// Check if user has been away for a specific duration
export const hasUserBeenAway = (thresholdMinutes = 10) => {
    const lastActivity = getLastActivity();
    const timeDiff = Date.now() - lastActivity;
    const thresholdMs = thresholdMinutes * 60 * 1000;

    return timeDiff > thresholdMs;
};

// Mark that user is away (when page becomes hidden)
export const markUserAway = () => {
    localStorage.setItem(STORAGE_KEYS.USER_AWAY, Date.now().toString());
};

// Check if user was marked as away and clear the flag
export const wasUserAway = () => {
    const awayTime = localStorage.getItem(STORAGE_KEYS.USER_AWAY);
    if (awayTime) {
        localStorage.removeItem(STORAGE_KEYS.USER_AWAY);
        return parseInt(awayTime);
    }
    return null;
};

// Detect if this is a fresh page load vs user returning
export const isPageRefresh = () => {
    // Use performance API to detect refresh
    if (window.performance) {
        const navigation = performance.getEntriesByType('navigation')[0];
        return navigation && navigation.type === 'reload';
    }
    return false;
};

// Create a debounced function to prevent excessive calls
export const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};